import { render, staticRenderFns } from "./HoldSaleModal.vue?vue&type=template&id=24aa6b74&scoped=true"
import script from "./HoldSaleModal.vue?vue&type=script&lang=js"
export * from "./HoldSaleModal.vue?vue&type=script&lang=js"
import style0 from "./HoldSaleModal.vue?vue&type=style&index=0&id=24aa6b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa6b74",
  null
  
)

export default component.exports